// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const asyncWait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export function isEqual<T>(obj1: T, obj2: T): boolean {
  return JSON.stringify(obj1) === JSON.stringify(obj2)
}
